(() => {
  const language = document.documentElement.lang.toLowerCase().split('-')[0];
  const titles = {
    it: ['Contatti', 'Chi siamo'],
    en: ['Contact', 'About us'],
    fr: ['Contact', 'À propos'],
  };
  const [contactTitle, aboutTitle] = titles[language] || titles.en;
  document.title = document.title.replace(new RegExp(`^${contactTitle}\\b`, 'i'), aboutTitle);

  const roots = document.querySelectorAll('[data-sc-about]');

  roots.forEach((root) => {
    const elements = root.querySelectorAll('[data-sc-about-reveal]');
    const bands = root.querySelectorAll('[data-sc-about-band]');
    const steps = root.querySelectorAll('[data-sc-process-step]');
    const postcards = root.querySelectorAll('[data-sc-about-postcard]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (
      !('IntersectionObserver' in window) ||
      reduceMotion
    ) {
      elements.forEach((element) => element.classList.add('is-visible'));
      bands.forEach((band) => band.classList.add('is-band-visible'));
      steps.forEach((step) => step.classList.add('is-step-visible'));
      return;
    }

    root.classList.add('is-motion-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12,
      }
    );

    elements.forEach((element, index) => {
      element.style.transitionDelay = `${Math.min(index % 3, 2) * 80}ms`;
      observer.observe(element);
    });

    const bandObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-band-visible');
          bandObserver.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.18,
      }
    );

    bands.forEach((band) => bandObserver.observe(band));

    const stepObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-step-visible');
          stepObserver.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.15,
      }
    );

    steps.forEach((step) => stepObserver.observe(step));

    postcards.forEach((postcard) => {
      let active = false;

      const updatePosition = (clientX) => {
        const bounds = postcard.getBoundingClientRect();
        const progress = Math.max(-1, Math.min(1, (clientX - bounds.left - bounds.width / 2) / (bounds.width / 2)));
        postcard.style.setProperty('--sc-postcard-shift', `${progress * 12}px`);
        postcard.style.setProperty('--sc-postcard-tilt', `${progress * 3.2}deg`);
      };

      const release = () => {
        active = false;
        postcard.classList.remove('is-grabbing');
        postcard.style.removeProperty('--sc-postcard-shift');
        postcard.style.removeProperty('--sc-postcard-tilt');
      };

      postcard.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        active = true;
        postcard.classList.add('is-grabbing');
        postcard.setPointerCapture(event.pointerId);
        updatePosition(event.clientX);
      });

      postcard.addEventListener('pointermove', (event) => {
        if (!active) return;
        updatePosition(event.clientX);
      });

      postcard.addEventListener('pointerup', release);
      postcard.addEventListener('pointercancel', release);
      postcard.addEventListener('lostpointercapture', release);
    });
  });
})();
